import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '../stores/auth';
import AuthenticatedLayout from '@/layouts/AuthenticatedLayout.vue';

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/',
            component: AuthenticatedLayout,
            children: [
                {
                    path: '/',
                    name: 'home',
                    component: () => import('../views/home/HomeView.vue')
                },
                {
                    path: '/packages',
                    name: 'packages',
                    component: () => import('../views/packages/ListView.vue'),
                    children: [
                        {
                            path: ':id',
                            name: 'packageCreation'
                        }
                    ]
                },
                {
                    path: '/packages-unprocessed',
                    name: 'UnprocessedPackages',
                    component: () =>
                        import(
                            '@/views/packages/UnprocessedPackagesListView.vue'
                        )
                },
                {
                    path: '/warehouses',
                    name: 'warehouses',
                    component: () =>
                        import('../views/Warehouse/WarehouseListView.vue'),
                    children: [
                        {
                            path: ':id',
                            name: 'warehouseCreation'
                        }
                    ]
                },
                {
                    path: '/warehouses-unprocessed',
                    name: 'UnprocessedWarehouses',
                    component: () =>
                        import(
                            '@/views/Warehouse/UnprocessedWarehouseListView.vue'
                        )
                },
                {
                    path: '/repacking',
                    name: 'repacking',
                    component: () =>
                        import('../views/repacking/RepackingListView.vue')
                },
                {
                    path: '/shipping-requests',
                    name: 'shipping-requests',
                    component: () =>
                        import('../views/repacking/ShippingRequestListView.vue')
                },
                {
                    path: '/template-builder',
                    name: 'template-builder',
                    component: () =>
                        import('../views/templateBuilder/templateBuilder.vue')
                },
                {
                    path: '/cities',
                    name: 'cities',
                    component: () => import('../views/city/CityListView.vue')
                },
                {
                    path: '/countries',
                    name: 'countries',
                    component: () =>
                        import('../views/country/CountryListView.vue')
                },
                {
                    path: '/loadunits',
                    name: 'loadUnits',
                    component: () =>
                        import('../views/loadunits/LoadUnitListView.vue')
                },
                {
                    path: '/prepack',
                    name: 'prepack',
                    component: () =>
                        import('../views/Prepack/PrepackListView.vue')
                },
                {
                    path: '/states',
                    name: 'states',
                    component: () => import('../views/State/StateListView.vue')
                },
                {
                    path: '/pdfviewer',
                    name: 'pdfViewer',
                    component: () => import('../views/PdfViewer/PdfViewer.vue')
                },
                {
                    path: '/invoices',
                    name: 'invoices',
                    component: () =>
                        import('../views/invoices/InvoiceListView.vue')
                },
                {
                    path: '/payments',
                    name: 'payments',
                    component: () =>
                        import('../views/payments/PaymentListView.vue')
                },
                {
                    path: '/pickups',
                    name: 'pickups',
                    component: () =>
                        import('../views/pickups/PickupListView.vue')
                },
                {
                    path: '/delivery-list',
                    name: 'delivery-list',
                    component: () =>
                        import('../views/deliveryList/DeliveryListView.vue')
                },
                {
                    path: '/routes-pickups',
                    name: 'routes-pickups',
                    component: () =>
                        import('../views/pickups/PickupRoutesListView.vue')
                },
                {
                    path: '/labelList',
                    name: 'labelList',
                    component: () =>
                        import('../views/configLabel/LabelList.vue')
                },
                {
                    path: '/consolidated',
                    name: 'consolidated',
                    component: () =>
                        import('../views/consolidated/ConsolidatedListView.vue')
                },
                {
                    path: '/alerts',
                    name: 'alerts',
                    component: () => import('../views/alerts/AlertListView.vue')
                },
                {
                    path: '/shipments',
                    name: 'shipments',
                    component: () =>
                        import('../views/shipments/ShipmentListView.vue')
                },
                {
                    path: '/shipments-unprocessed',
                    name: 'UnprocessedShipments',
                    component: () =>
                        import(
                            '@/views/shipments/UnprocessedShipmentListView.vue'
                        )
                },
                {
                    path: '/customers',
                    name: 'customers',
                    component: () =>
                        import('../views/customers/CustomerListView.vue')
                },
                {
                    path: '/agencies',
                    name: 'agencies',
                    component: () =>
                        import('../views/agency/AgencyListView.vue')
                },
                {
                    path: '/agents',
                    name: 'agents',
                    component: () => import('../views/agents/AgentListView.vue')
                },
                {
                    path: '/consolidated-type',
                    name: 'consolTypes',
                    component: () =>
                        import(
                            '../views/consolidatedType/ConsolTypeListView.vue'
                        )
                },
                {
                    path: '/template-packs',
                    name: 'templatePacks',
                    component: () =>
                        import(
                            '../views/templatePacks/TemplatePackListView.vue'
                        )
                },
                {
                    path: '/users',
                    name: 'users',
                    component: () => import('../views/users/UserListView.vue')
                },
                {
                    path: '/zones',
                    name: 'zones',
                    component: () => import('../views/zones/ZoneListView.vue')
                },
                {
                    path: '/locations',
                    name: 'locations',
                    component: () =>
                        import('../views/locations/LocationsListView.vue')
                },
                {
                    path: '/body-email',
                    name: 'body-email',
                    component: () =>
                        import('../views/bodyEmail/BodyEmailListView.vue')
                },
                {
                    path: '/regions',
                    name: 'regions',
                    component: () =>
                        import('../views/regions/RegionsListView.vue')
                },
                {
                    path: '/warehouse-tariff',
                    name: 'warehouseRate',
                    component: () =>
                        import('../views/tariff/WarehouseRateListView.vue')
                },
                {
                    path: '/company',
                    name: 'company',
                    component: () =>
                        import('../views/company/CompanyListView.vue')
                },
                {
                    path: '/correlative',
                    name: 'correlative',
                    component: () =>
                        import('../views/correlative/CorrelativeListView.vue')
                },
                {
                    path: '/carriers',
                    name: 'carriers',
                    component: () =>
                        import('../views/carrier/CarrierListView.vue')
                },
                {
                    path: '/pack-types',
                    name: 'packTypes',
                    component: () =>
                        import('../views/packType/PackTypeListView.vue')
                },
                {
                    path: '/terms-and-conditions',
                    name: 'termsAndConditions',
                    component: () =>
                        import(
                            '../views/termsAndConditions/TermAndConditionsListView.vue'
                        )
                },
                {
                    path: '/vehicles',
                    name: 'vehicles',
                    component: () =>
                        import('../views/vehicle/VehicleListView.vue')
                },
                {
                    path: '/accounts',
                    name: 'accounts',
                    component: () =>
                        import('../views/account/AccountListView.vue')
                },
                {
                    path: '/branches',
                    name: 'branches',
                    component: () =>
                        import('../views/branch/BranchListView.vue')
                },
                {
                    path: '/local-transporters',
                    name: 'localTransporters',
                    component: () =>
                        import(
                            '../views/localTransporters/LocalTransportersListView.vue'
                        )
                },
                {
                    path: '/sea-ports',
                    name: 'seaPorts',
                    component: () =>
                        import('../views/seaPort/SeaPortListView.vue')
                },
                {
                    path: '/paid-types',
                    name: 'paidTypes',
                    component: () =>
                        import('../views/paidType/PaidTypeListView.vue')
                },
                {
                    path: '/config-deployment',
                    name: 'configDeployment',
                    component: () =>
                        import(
                            '../views/configDeployment/ConfigDeploymentListView.vue'
                        )
                },
                {
                    path: '/config-label',
                    name: 'configLabel',
                    component: () =>
                        import('../views/configLabel/ConfigLabelListView.vue')
                },
                {
                    path: '/shipment-tariff',
                    name: 'shipmentRate',
                    component: () =>
                        import('../views/tariff/ShipmentRateListView.vue')
                },
                {
                    path: '/email-setup',
                    name: 'emailSetup',
                    component: () => import('../views/home/HomeView.vue'),
                    meta: { openEmailSetup: true }
                },
                {
                    path: '/public-links',
                    name: 'publicLoginLink',
                    component: () =>
                        import('../views/publicLinks/PublicLinkView.vue')
                },
                {
                    path: '/quickbooks-setup',
                    name: 'quickbooksSetup',
                    component: () => import('../views/home/HomeView.vue'),
                    meta: { openQuickBooksSetup: true }
                },
                {
                    path: '/zoom-carrier-setup',
                    name: 'zoomCarrierSetup',
                    component: () => import('../views/home/HomeView.vue'),
                    meta: { openZoomCarrierSetup: true }
                },
                {
                    path: '/transporters',
                    name: 'transporters',
                    component: () =>
                        import('../views/transporter/TransporterListView.vue')
                },
                {
                    path: '/service',
                    name: 'service',
                    component: () =>
                        import('../views/service/ServiceListView.vue')
                },
                {
                    path: '/step-status',
                    name: 'stepStatus',
                    component: () =>
                        import('../views/stepStatus/StepStatusListView.vue')
                },
                {
                    path: '/pobox',
                    name: 'poBox',
                    component: () => import('../views/pobox/PoboxListView.vue')
                },
                {
                    path: '/invoices',
                    name: 'invoices',
                    component: () =>
                        import('../views/invoices/InvoiceListView.vue')
                },
                {
                    path: '/whatsapp-templates',
                    name: 'whatsappTemplates',
                    component: () =>
                        import(
                            '../views/whatsappTemplates/WhatsappTemplatesListView.vue'
                        )
                },
                {
                    path: '/global-search',
                    name: 'globalSearch',
                    component: () =>
                        import('../views/globalSearch/GlobalSearchView.vue')
                }
            ]
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('../views/Auth/LoginView.vue')
        },
        {
            path: '/:acronym/login',
            name: 'loginByAcronym',
            component: () => import('../views/Auth/LoginView.vue'),
            props: true
        },
        {
            path: '/:companyName/register',
            name: 'register',
            component: () => import('../views/Auth/RegisterView.vue'),
            props: true
        },
        {
            path: '/checkout/success',
            name: 'checkoutSuccess',
            component: () => import('../views/checkout/CheckoutSuccessView.vue')
        },
        {
            path: '/pricing',
            name: 'pricing',
            component: () => import('../views/pricing/PricingView.vue')
        }
    ]
});

router.beforeEach(async (to) => {
    const publicPages = [
        'login',
        'register',
        'loginByAcronym',
        'checkoutSuccess',
        'pricing'
    ];
    const authRequired = !publicPages.includes(to.name);
    const authStore = useAuthStore();
    const isAuthenticated = authStore.isAuthenticated;

    if (!isAuthenticated && authRequired) {
        return { name: 'login' };
    }

    const pagesToAuth = ['login'];
    if (pagesToAuth.includes(to.name) && isAuthenticated) {
        return { name: 'packages' };
    }
});

export default router;
